import { Errors, useErrorNotificationApi, useRefreshApi } from '@equifinance/shared';
import {
  AddBrokerUserPayload, BrokerDetails, CompanyUsers, UpdateBrokerUserPayload,
} from '../contexts/broker/Broker';

const apiPath = `${process.env.REACT_APP_BROKER_MANAGEMENT_API_AUTH_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type GetBrokerUserResponse = BrokerDetails & {
  errors: Errors,
}

export type PutUpdateBrokerUserPayload = BrokerDetails & {
  companyId: string;
}

export type BrokerManagementApiType = {
  getBrokerUser: (brokerUserId: string) => Promise<GetBrokerUserResponse>,
  putUpdateBrokerUser: (payload: PutUpdateBrokerUserPayload) => Promise<GetBrokerUserResponse>
  getCompanyUsers: (companyId: string) => Promise<CompanyUsers>,
  postAddCompanyUser: (brokerUserPayload: AddBrokerUserPayload) => Promise<CompanyUsers>,
  postResendRegistrationToken: (userEmail: string) => Promise<Record<string, any>>,
  putReactivateUser: (userEmail: string) => Promise<CompanyUsers>,
  putDeactivateUser: (userEmail: string) => Promise<CompanyUsers>,
  putUpdateCompanyUser: (brokerUserPayload: UpdateBrokerUserPayload) => Promise<CompanyUsers>,
}

const useBrokerApi = (): BrokerManagementApiType => {
  const {
    get,
    put,
  } = useRefreshApi(apiUrl);

  const {
    get: getWithErrHandler,
    post: postWithErrHandler,
    put: putWithErrHandler,
  } = useErrorNotificationApi(apiUrl);

  return {
    getBrokerUser: (brokerUserId: string): Promise<GetBrokerUserResponse> => get(`user/${brokerUserId}`),
    putUpdateBrokerUser: (payload: PutUpdateBrokerUserPayload) => put('user/update-user', payload),
    getCompanyUsers: (companyId: string) => getWithErrHandler(`user/users/${companyId}`),
    postAddCompanyUser: (brokerUserPayload: AddBrokerUserPayload) => postWithErrHandler('user/add-company-user', brokerUserPayload),
    postResendRegistrationToken: (userEmail: string) => postWithErrHandler('user/resend-registration-token', { emailAddress: userEmail }),
    putReactivateUser: (userEmail: string) => putWithErrHandler(`user/admin/reactivate-user/${userEmail}`, {}),
    putDeactivateUser: (userEmail: string) => putWithErrHandler(`user/admin/deactivate-user/${userEmail}`, {}),
    putUpdateCompanyUser: (brokerUserPayload: UpdateBrokerUserPayload) => putWithErrHandler('user/update-company-user', brokerUserPayload),
  };
};

export default useBrokerApi;
